export const getAvailablePurchaseMethods = (offers) =>
  Array.from(new Set(offers.map((offer) => offer.purchaseMethod))).filter(
    Boolean
  );
